import { createSelector } from 'reselect';

const providerListSelector = store => store.communications.typedProvidersList;
const editTemplateSelector = store => store.templates.currentEditTemplate;

export const getTemplateWithCommunicationProvider = createSelector(
    providerListSelector,
    editTemplateSelector,
    (communicationsProviderList, currentEditTemplate) => {
        const { communication_provider } = currentEditTemplate;

        if (communication_provider) {
            return currentEditTemplate
        }
        if (communicationsProviderList.length) {
            const [ defaultCommunicationProvider ] = communicationsProviderList;
            return { ...currentEditTemplate, communication_provider: defaultCommunicationProvider }
        } else {
            return currentEditTemplate
        }
    }
);
export const getMergedEmailTemplates = createSelector(
    store => store.templates.list.Email,
    store => store.templates.list.EmailBuilded,
    (emailTemplatesList, emailBuildedTemplatesList ) => [...emailTemplatesList, ...emailBuildedTemplatesList]
)
